(function() {
      const initBreadcrumb = () => {
        const containers = document.querySelectorAll(".history-breadcrumb-container");
        if (!containers.length) return;

        const currentUrl = window.location.href;
        const referrer = document.referrer;
        const isInternalReferrer = referrer && referrer.startsWith(window.location.origin);

        let historyStack = [];

        try {
          const storedHistory = sessionStorage.getItem("custom_breadcrumb_history");
          historyStack = storedHistory ? JSON.parse(storedHistory) : [];
        } catch (e) {
          historyStack = [];
        }

        if (!Array.isArray(historyStack)) historyStack = [];

        if (!isInternalReferrer) {
          historyStack = [currentUrl];
        } else {
          const index = historyStack.indexOf(currentUrl);
          if (index !== -1) {
            historyStack = historyStack.slice(0, index + 1);
          } else {
            if (historyStack.length === 0) {
              historyStack.push(referrer);
            } else if (historyStack[historyStack.length - 1] !== referrer) {
              historyStack.push(referrer);
            }
            historyStack.push(currentUrl);
          }
        }

        try {
          sessionStorage.setItem("custom_breadcrumb_history", JSON.stringify(historyStack));
        } catch (e) {}

        let targetBackUrl = null;
        const currentIndex = historyStack.indexOf(currentUrl);

        if (currentIndex > 0) {
          targetBackUrl = historyStack[currentIndex - 1];
        } else if (isInternalReferrer && referrer !== currentUrl) {
          targetBackUrl = referrer;
        } else {
          const path = window.location.pathname;
          if (path.includes('/products/')) {
            targetBackUrl = window.location.origin + '/collections/all';
          } else if (path.includes('/collections/')) {
            targetBackUrl = window.location.origin + '/pages/beauty-and-wellness';
          } else {
            targetBackUrl = window.location.origin + '/';
          }
        }

        containers.forEach((container) => {
          const backButton = container.querySelector(".history-back-button");
          const backSeparator = container.querySelector(".back-separator");

          if (backButton) {
            if (!targetBackUrl) {
              backButton.style.display = "none";
              if (backSeparator) backSeparator.style.display = "none";
            } else {
              backButton.addEventListener("click", (e) => {
                e.preventDefault();
                window.location.href = targetBackUrl;
              });
            }
          }
        });
      };

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initBreadcrumb);
      } else {
        initBreadcrumb();
      }
    })();